module.exports = __webpack_public_path__ + "img/planejamento@2x.b7659c42.png";